// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  CanonicalAddress,
  SmbOnboardingFlowKind,
  InvitedOnboardingStep,
} from "./types";


export default __t.row({
  googlePlaceId: __t.option(__t.string()).name("google_place_id"),
  googlePlacePhotoName: __t.option(__t.string()).name("google_place_photo_name"),
  name: __t.option(__t.string()),
  get businessAddress() {
    return __t.option(CanonicalAddress).name("business_address");
  },
  businessCategory: __t.option(__t.string()).name("business_category"),
  businessType: __t.option(__t.string()).name("business_type"),
  websiteUrl: __t.option(__t.string()).name("website_url"),
  nominatedBusinessV1: __t.option(__t.string()).name("nominated_business_v_1"),
  claimRequestId: __t.option(__t.string()).name("claim_request_id"),
  heroCdnPath: __t.option(__t.string()).name("hero_cdn_path"),
  colorPrimary: __t.option(__t.string()).name("color_primary"),
  colorSecondary: __t.option(__t.string()).name("color_secondary"),
  colorTertiary: __t.option(__t.string()).name("color_tertiary"),
  colorText: __t.option(__t.string()).name("color_text"),
  browsable: __t.bool(),
  businessTags: __t.array(__t.string()).name("business_tags"),
  get flowKind() {
    return SmbOnboardingFlowKind.name("flow_kind");
  },
  sourceInvitedBrandDraft: __t.option(__t.uuid()).name("source_invited_brand_draft"),
  get invitedStep() {
    return __t.option(InvitedOnboardingStep).name("invited_step");
  },
});
